import { render, staticRenderFns } from "./questionRequisitionForm.vue?vue&type=template&id=72ecba9d&scoped=true&"
import script from "./questionRequisitionForm.vue?vue&type=script&lang=js&"
export * from "./questionRequisitionForm.vue?vue&type=script&lang=js&"
import style0 from "./questionRequisitionForm.vue?vue&type=style&index=0&id=72ecba9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ecba9d",
  null
  
)

export default component.exports